import React from 'react';
import { useLocation, withRouter } from 'react-router-dom';

export const PageLocation = withRouter(function PageLocationComponent({
  location,
  children,
}) {
  useScrollToTop(location.pathname);
  return <>{children}</>;
});

/** @deprecated use useLocation() from 'react-router-dom' instead */
export function usePageLocation() {
  return useLocation();
}

function useScrollToTop(pathname = '/') {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}
